import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import IncompleteFollowupsList from "../IncompleteFollowupsList";
import CompletedFollowupsList from "../CompletedFollowupsList";
import { useCurrentUser } from "../../../../hooks";

const FollowupsListContainer = ({
  followups,
  isCompletedSection,
  sectionType,
  handleClick,
  setFollowups,
  handleOpenFollowupAdd,
  isUsersOwnFollowups,
  showManagerReviews,
}) => {
  const user = useCurrentUser();
  // eslint-disable-next-line no-unused-vars
  const activeEmployeeNumber = user?.employeeNumber;

  const [incompleteFollowups, setIncompleteFollowups] = useState([]);
  const [completedFollowups, setCompletedFollowups] = useState([]);

  useEffect(() => {
    const incompleteFollowupsFiltered = followups.filter(
      (followup) =>
        followup.status === "Active"
    );

    const completedFollowupsFiltered = followups?.filter(
      (followup) =>
        followup.status === "COMPLETED"
    ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    setIncompleteFollowups(incompleteFollowupsFiltered);
    setCompletedFollowups(completedFollowupsFiltered);
  }, [followups]);

  if (isCompletedSection) {
    return (
      <ul>
        <div className="list-container">
          {followups.length ? (
            <React.Fragment>
              <CompletedFollowupsList
                completedFollowups={completedFollowups}
                followupsLength={completedFollowups?.length}
                handleClick={handleClick}
                sectionType={sectionType}
                setFollowups={setFollowups}
              />
            </React.Fragment>
          ) : (
            <div style={{ margin: "1rem" }}>No results found...</div>
          )}
        </div>
      </ul>
    );
  }


    return (
      <ul>
        <div className="list-container" style={{overflowY: "visible"}}>
          {!incompleteFollowups.length ? (
            <div style={{ margin: "1rem" }}>No results found...</div>
          ) : (
            <React.Fragment>
              <IncompleteFollowupsList
                followupsLength={incompleteFollowups?.length}
                handleClick={handleClick}
                handleOpenFollowupAdd={handleOpenFollowupAdd}
                incompleteFollowups={incompleteFollowups}
                isUsersOwnFollowups={isUsersOwnFollowups}
                setFollowups={setFollowups}
                showManagerReviews={showManagerReviews}
              />
            </React.Fragment>
          )}
        </div>
      </ul>
    );
};

FollowupsListContainer.propTypes = {
  followups: PropTypes.array.isRequired,
  sectionType: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  setFollowups: PropTypes.func.isRequired,
  isCompletedSection: PropTypes.bool,
  handleOpenFollowupAdd: PropTypes.func.isRequired,
  isUsersOwnFollowups: PropTypes.bool,
  showManagerReviews: PropTypes.bool
};

FollowupsListContainer.defaultProps = {
  sectionType: "",
  isCompletedSection: false,
  isUsersOwnFollowups: false,
  showManagerReviews: false
};

export default FollowupsListContainer; 